<template>
  <div class="rounded border bg-white info-panel mb-3">
    <div class="text-gray-800 px-6 py-3 fw-bold fs-5 border-bottom">Акт выполненных работ</div>
    <div class="rounded bg-white info-panel custom-table">
      <div class="table-responsive" v-if="lists && !avrsLoaded">
        <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800"
               style="white-space: nowrap !important;">
          <thead>
            <tr class="fw-bold fs-8 text-gray-400">
              <th class="w-75px">ID</th>
              <th>Номер</th>
              <th>Дата</th>
              <th>Оплачено</th>
              <th>Подтвержденный</th>
              <th class="text-end w-125px">Действие</th>
            </tr>
          </thead>
          <tbody>
            <tr class="cursor-pointer align-middle" v-for="item in lists.data" :key="item.id" @click="openAvrModal(item.id, item.number)">
              <td v-html="item.id"></td>
              <td v-html="item.number"></td>
              <td v-html="item.date"></td>
              <td>{{item.is_paid   === null ? 'Необработанный' : item.is_paid   === 0 ? 'Нет' : 'Да'}}</td>
              <td>{{item.confirmed === null ? 'Необработанный' : item.confirmed === 0 ? 'Нет' : 'Да'}}</td>
              <td class="text-end"><i class="ki-outline ki-right-square text-primary fs-4"></i></td>
            </tr>
          </tbody>
        </table>
        <bootstrap5-pagination class="pagination-outline pt-3 mb-3 border-top" v-if="lists" :data="lists" @pagination-change-page="getAvrs"/>
      </div>
      <loader-full v-else/>
      <avr-modal @reload="reloadPage"/>
    </div>
  </div>
</template>

<script>
import { Bootstrap5Pagination } from 'laravel-vue-pagination';
import LoaderFull               from '@/components/Main/LoaderFull';
import AvrModal                 from '@/components/Modals/AvrModal';
import axios                    from "axios";

export default {
  name: 'AVR',
  components: {AvrModal, LoaderFull, Bootstrap5Pagination},
  data () {
    return {
      avrsLoaded: false,
      lists:      null,
      page:       1
    }
  },
  mounted() {
    this.getAvrs()
  },
  methods: {
    getAvrs(page = 1) {
      this.avrsLoaded = true
      axios.get('/api/avr/all?page='+page)
          .then(res => {
            this.lists  = Object.assign(res.data, res.data.meta)
            delete this.lists['meta']
            this.page   = page
          })
          .catch(err => {console.log(err)})
          .finally(() => {this.avrsLoaded = false})
    },
    openAvrModal(id, title) {
      this.$store.dispatch('avrModel', {id:id, title:title})
      new bootstrap.Modal('#avrModal', {}).show()
    },
    reloadPage(val) {
      if (val.reload) this.getAvrs(this.page)
    }
  }
}
</script>

<style scoped>

</style>